"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exportChatTranslations = {
    exportChat: "Export Chat",
    searchPatient: "Search by patient name",
    fromDate: "From date",
    toDate: "To Date",
    status: "Status",
    reset: "Reset",
    filter: "Filter",
    sNo: "No.",
    all: "All",
    completed: "COMPLETED",
    failed: "FAILED",
    inProgress: "IN PROGRESS",
    success: "We will notify you when files are ready for download",
    noRecordFound: "No records found",
    exportMedia: "Export Media",
    exportChatError: "Chat file not found",
    exportMediaError: "Chat Media file not found",
};
exports.default = exportChatTranslations;
